import { Component, Input, TemplateRef, ContentChild, Optional } from '@angular/core';
import { AccordionComponent } from '../accordion.component';

@Component({
    selector: 'accordion-tab',
    templateUrl: './accordion-tab.component.html',
    styleUrl: './accordion-tab.component.scss',
    standalone: false
})
export class AccordionTabComponent {
  @Input() header?: string;
  @Input() disabled = false;
  active = false;

  @ContentChild('pTemplate') headerTemplate?: TemplateRef<any>;

  constructor(
    @Optional() private accordion: AccordionComponent
  ) { }

  toggleSelf() {
    if (this.disabled || !this.accordion) return;
    const tabs = this.accordion.tabs.toArray();
    const index = tabs.indexOf(this);
    this.accordion.toggle(this, index);
  }

  get expandIcon() {
    return this.accordion?.expandIcon ?? 'icon-plus';
  }

  get collapseIcon() {
    return this.accordion?.collapseIcon ?? 'icon-minus';
  }
}
